import { useCallback, useMemo } from 'react'

import { deleteCookie, getCookie, setCookie } from '~/utils/cookie.utils'

export const useCampaignReferrer = (options?: {
  isCampaignPage: boolean
}): { referrer: string | undefined; clearReferrer: () => void } => {
  const referrer = useMemo(() => {
    if (typeof window === 'undefined') return
    const queryParam = location.search
    const isCampaign = location.search.includes('utm_campaign')
    const campaignReferrer = getCookie('campaignReferrer')
    const url = location.href

    if (queryParam && isCampaign && options?.isCampaignPage) {
      setCookie({
        name: 'campaignReferrer',
        value: url.toString(),
        expireInDays: 10,
      })
      return url
    }

    return campaignReferrer
  }, [options?.isCampaignPage])

  const clearReferrer = useCallback(() => {
    deleteCookie('campaignReferrer')
  }, [])

  return { referrer, clearReferrer }
}
